export default __webpack_public_path__ + "static/media/iconDownload.a1adce9e.svg";